import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=57f51a76&scoped=true&"
import script from "./ActivityDetail.vue?vue&type=script&lang=js&"
export * from "./ActivityDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDetail.vue?vue&type=style&index=0&id=57f51a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f51a76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f51a76')) {
      api.createRecord('57f51a76', component.options)
    } else {
      api.reload('57f51a76', component.options)
    }
    module.hot.accept("./ActivityDetail.vue?vue&type=template&id=57f51a76&scoped=true&", function () {
      api.rerender('57f51a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ActivityDetail/ActivityDetail.vue"
export default component.exports